import TranslatedYesNoQuestion from "../../atoms/TranslatedYesNoQuestion";

const ElectricRenewablesYesNoQuestion = ({
  questionText,
  isElectricRenewablesPercentageGiven,
  editIsElectricRenewablesPercentageGiven,
  disabled,
}) => (
  <TranslatedYesNoQuestion
    question={questionText}
    value={isElectricRenewablesPercentageGiven}
    setValue={editIsElectricRenewablesPercentageGiven}
    disabled={disabled}
  />
);
export default ElectricRenewablesYesNoQuestion;
